import { lazy } from 'react';

import {
  HIRING_V2_JOB_BOOST_MODAL,
  HIRING_V2_JOB_BOOST_NO_BOOST_MODAL,
  HIRING_V2_MEMBER_ADDED_MODAL,
  HIRING_V2_NYLAS_DECLINE_INTERVIEW_MODAL,
  HIRING_V2_NYLAS_LINK_TO_SCHEDULE_INTERVIEW_MODAL,
  HIRING_V2_NYLAS_SCHEDULE_INTERVIEW_TOP_MATCH_MODAL,
  HIRING_V2_SHARE_OPPORTUNITY_MODAL,
  HIRING_V2_SKIP_ADD_MEMBER_TO_TEAM_MODAL,
  HIRING_V2_VERIFY_CANCEL_INTERVIEW_TIMES_MODAL,
} from './constants';

const MemberAddedModal = lazy(
  () =>
    import(
      /* webpackChunkName: "MemberAddedModal" */ '../shared/components/Interview/Modals/MemberAddedModal'
    )
);

const JobBoostModal = lazy(
  () =>
    import(
      /* webpackChunkName: "JobBoostModal" */ '../shared/components/Boost/BoostModal'
    )
);

const JobBoostNoBoostModal = lazy(
  () =>
    import(
      /* webpackChunkName: "JobBoostNoBoostModal" */ '../shared/components/Boost/NoBoostModal'
    )
);

const SendLinkToScheduleModal = lazy(
  () =>
    import(
      /* webpackChunkName: "SendLinkToScheduleModal" */ '../ReviewCandidates/modals/LinkToSchedule'
    )
);

const ScheduleInterviewWithTopMatchModal = lazy(
  () =>
    import(
      /* webpackChunkName: "ScheduleInterviewWithTopMatchModal" */ '../ReviewCandidates/modals/InterviewTopMatch'
    )
);

const DeclineInterviewModal = lazy(
  () =>
    import(
      /* webpackChunkName: "DeclineInterviewModal" */ '../ReviewCandidates/modals/DeclineInterview'
    )
);

const SkipAddMemberToTeamModal = lazy(
  () =>
    import(
      /* webpackChunkName: "SkipAddMemberToTeamModal" */ '../shared/components/Interview/Modals/SkipAddMemberToTeamModal'
    )
);

const VerifyCancelInterviewTimesModal = lazy(
  () =>
    import(
      /* webpackChunkName: "VerifyCancelInterviewTimesModal" */ '../Dashboard/VerifyCancelInterviewTimesModal'
    )
);

const ShareOpportunityModal = lazy(
  () =>
    import(
      /* webpackChunkName: "ShareOpportunityModal" */ '../shared/components/Sharing/ShareOpportunityModal'
    )
);

export const HIRING_V2_MODAL_COMPONENTS = {
  [HIRING_V2_MEMBER_ADDED_MODAL]: MemberAddedModal,
  [HIRING_V2_JOB_BOOST_MODAL]: JobBoostModal,
  [HIRING_V2_JOB_BOOST_NO_BOOST_MODAL]: JobBoostNoBoostModal,
  [HIRING_V2_NYLAS_LINK_TO_SCHEDULE_INTERVIEW_MODAL]: SendLinkToScheduleModal,
  [HIRING_V2_NYLAS_SCHEDULE_INTERVIEW_TOP_MATCH_MODAL]:
    ScheduleInterviewWithTopMatchModal,
  [HIRING_V2_SKIP_ADD_MEMBER_TO_TEAM_MODAL]: SkipAddMemberToTeamModal,
  [HIRING_V2_NYLAS_DECLINE_INTERVIEW_MODAL]: DeclineInterviewModal,
  [HIRING_V2_VERIFY_CANCEL_INTERVIEW_TIMES_MODAL]:
    VerifyCancelInterviewTimesModal,
  [HIRING_V2_SHARE_OPPORTUNITY_MODAL]: ShareOpportunityModal,
};
